import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import phone from "../../data/phone.json";

const InputSelect = ({ value, onChange, error = false, helperText = "" }) => {
  const options = phone.map((phone) => ({
    label: `${phone.dial_code} (${phone.code})`,
    value: phone.dial_code + " (" + phone.code + ")",
    code: phone.code,
  }));

  return (
    <Autocomplete
      options={options}
      value={options.find((option) => option.value === value) || null}
      onChange={(event, newValue) => onChange(newValue?.value || "")}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label="Indicatif"
          required
          error={error}
          helperText={helperText}
        />
      )}
      filterOptions={(options, state) => {
        const input = state.inputValue.toLowerCase();
        return options.filter(
          (option) =>
            option.label.toLowerCase().includes(input) ||
            option.code.toLowerCase().startsWith(input)
        );
      }}
      sx={{ width: 180 }}
    />
  );
};

export default InputSelect;
